/**
 * BrewNectar Product Reviews — carousel scroll, drag, fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    var animated = root.querySelectorAll('.bn-ppr__animate');

    if (
      prefersReducedMotion() ||
      !('IntersectionObserver' in window) ||
      (typeof Shopify !== 'undefined' && Shopify.designMode)
    ) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-ppr-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-bn-ppr-track]');
    if (!track) return;

    var scrollAmount = parseInt(root.getAttribute('data-bn-ppr-scroll-amount'), 10) || 400;
    var enableDrag =
      root.getAttribute('data-bn-ppr-enable-drag') !== 'false' && !prefersReducedMotion();
    var arrows = root.querySelectorAll('[data-bn-ppr-arrow]');

    arrows.forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.getAttribute('data-bn-ppr-arrow');
        var delta = direction === 'left' ? -scrollAmount : scrollAmount;
        track.scrollBy({ left: delta, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      });
    });

    if (!enableDrag) return;
    // On mobile: auto-scroll carousel instead of drag
    if (window.matchMedia("(max-width: 767px)").matches) {
      var cards = track.querySelectorAll('.bn-ppr__cell');
      if (cards.length <= 1) return;
      var currentIndex = 0;
      var autoScrollInterval = setInterval(function() {
        currentIndex = (currentIndex + 1) % cards.length;
        // Use scrollLeft on the track container — never scrollIntoView (causes page jumps)
        var cardWidth = cards[0].offsetWidth;
        var gap = parseInt(getComputedStyle(track).gap) || 20;
        track.scrollTo({ left: currentIndex * (cardWidth + gap), behavior: 'smooth' });
      }, 4000);
      // Pause auto-scroll if user manually scrolls
      track.addEventListener('touchstart', function() {
        clearInterval(autoScrollInterval);
      }, { passive: true });
      return;
    }

    var isPointerDown = false;
    var startX = 0;
    var startY = 0;
    var scrollLeft = 0;
    var moved = false;

    function getPageX(event) {
      if (event.pageX != null) return event.pageX;
      if (event.touches && event.touches[0]) return event.touches[0].pageX;
      if (event.changedTouches && event.changedTouches[0]) return event.changedTouches[0].pageX;
      return 0;
    }

    function onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      isPointerDown = true;
      moved = false;
      startX = getPageX(event);
      startY = event.touches && event.touches[0] ? event.touches[0].pageY : (event.pageY || 0);
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    }

    function onPointerMove(event) {
      if (!isPointerDown) return;
      var pageX = getPageX(event);
      var walk = pageX - startX;
      if (Math.abs(walk) > 3) moved = true;
      // Only prevent vertical scroll if horizontal drag exceeds threshold
      if (event.cancelable && event.type === 'touchmove') {
        var deltaX = Math.abs(getPageX(event) - startX);
        var deltaY = event.touches && event.touches[0] ? Math.abs(event.touches[0].pageY - startY) : 0;
        if (deltaX > deltaY && deltaX > 10) {
          event.preventDefault();
        } else if (deltaY > deltaX) {
          // User is scrolling vertically — release the drag
          isPointerDown = false;
          track.classList.remove('is-dragging');
          return;
        }
      }
      track.scrollLeft = scrollLeft - walk;
    }

    function onPointerUp() {
      isPointerDown = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('mousedown', function (event) {
      onPointerDown(event);
    });
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    track.addEventListener('touchmove', onPointerMove, { passive: false });
    track.addEventListener('touchend', onPointerUp);
    track.addEventListener('touchcancel', onPointerUp);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);

    track.addEventListener(
      'click',
      function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function initCtaSmoothScroll(root) {
    var cta = root.querySelector('[data-bn-ppr-cta]');
    if (!cta) return;

    cta.addEventListener('click', function (event) {
      var href = cta.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var target = document.getElementById(href.slice(1));
      if (!target) return;

      event.preventDefault();
      if (window.BrewNectarScroll) {
        window.BrewNectarScroll.scrollToElement(target);
      } else {
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnPprInit === 'true') return;
    root.dataset.bnPprInit = 'true';

    if (root.classList.contains('bn-ppr--static')) {
      root.querySelectorAll('.bn-ppr__animate').forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      initFadeUp(root);
    }

    initCarousel(root);
    initCtaSmoothScroll(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-ppr').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-ppr');
    if (root) {
      delete root.dataset.bnPprInit;
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.bn-ppr');
    if (root) delete root.dataset.bnPprInit;
  });
})();
